import type { DB } from '@/lib/kysely-d'

export type Key = `/${keyof DB}/${string}` | `/${keyof DB}/order/${string}`

interface CreateKeyOrderOption {
  isOrder: boolean
}

export const createKey = (
  type: keyof DB,
  context: Record<string, any> | string,
  options?: CreateKeyOrderOption
): Key => {
  const isOrder = options?.isOrder ?? false
  const orderSegment = isOrder ? '/order' : ''
  if (typeof context === 'string') {
    return `/${type}${orderSegment}/${context}`
  } else {
    // Need sort keys, Key-Order of JSON.stringify may not guaranteed.
    const s = JSON.stringify(context, Object.keys(context).sort())
    return `/${type}${orderSegment}/${s}`
  }
}

export const isOrder = (key: string): boolean => {
  return key.includes('/order/')
}
